import React from "react";
import { AuthPage } from "../auth/auth-page";

export const Login = () => <AuthPage view="login" />;
